export default [
  'M33.62 13.07c.33-.12.55-.42.55-.76s-.22-.64-.55-.76L6.12 1.72a.821.821 0 00-.76.1c-.23.14-.36.39-.36.66V37.5c0 .45.37.83.83.83s.83-.39.83-.83V22.7l26.96-9.63zM6.67 3.64l24.25 8.67-24.25 8.66V3.64z',
];
